// From NF-1004 this page have been change from "Home charges" to "My charges"
(function () {
    var MyChargesCtrl = (function () {
        function MyChargesCtrl() {
            this.init.apply(this, arguments);
        }

        MyChargesCtrl.prototype = {
            init: function ($scope, $state, $rootScope, $stateParams, localStorageService, $mdDialog, $ionicScrollDelegate, $timeout, MKioskService, $message, $q) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.localStorageService = localStorageService;
                this.$mdDialog = $mdDialog;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.$timeout = $timeout;
                this.MKioskService = MKioskService;
                this.$message = $message;
                this.$q = $q;

                this.myChargesData = [];
                var self = this;

                this.homeChargersWithSyncError = null;

                /**
                 * NF-1004:
                 * As of today, we will keep this mechanism simple. It will be reviewed with the new mobile version to make it easier to select quickly, period.

                    The default value will be the last 6 months:

                    As of 14/01/2025, we will display the period 01/07/2024 - 31/12/2024
                    As of 01/02/2025, we will display the period 01/08/2024 - 31/01/2025
                    As of 30/03/2025, we will display the period 01/09/2024 - 28/02/2025
                 */
                this.periodStartDate = moment().add(-6, 'M').startOf('M');
                this.periodEndDate = moment().add(-1, 'M').endOf('M');

                this.restorePeriod();

                    // NF-1004: provide by Fred about /mobile/MyCharges/GetMyChargesData
                    /*
                        POST dto
                        public sealed class MyChargesRequestDto
                        {
                            public Date StartDate { get; set; }
                            public Date EndDate { get; set; }
                        }
                     */
                    /*
                        JSON returned

                        public sealed class MyChargesResponseDto
                        {
                            public ElectricityConsumptionDto Home { get; set; }
                            public ElectricityConsumptionDto Office { get; set; }
                            public ElectricityConsumptionDto Public { get; set; }
                        }

                        public sealed class ElectricityConsumptionDto
                        {
                            public int Energy { get; set; } // kWh
                            public decimal UnitCost { get; set; } // euro/kWh
                            public decimal CostIncreaseVsCheapestOption { get; set; } // %
                            public decimal Usage { get; set; } // %
                            public List<ConsumptionPerPeriodDto> ConsumptionPerPeriods { get; set; }
                        }

                        public sealed class ConsumptionPerPeriodDto
                        {
                            public string Period { get; set; } // either "yyyy-MM" or "lbConsumptionsForOngoingPeriod"
                            public decimal Energy { get; set; } // kWk
                            public decimal Cost { get; set; } // eur
                        }
                     */                  
                this.loadData().then(angular.bind(this, function (chargeData) {
                    self.myChargesData = chargeData;
                }), this.$message.error);
            },
            back: function () {
                sessionStorage.removeItem('mycharges-period');
                this.$state.go("internal.home");
            },
            loadData: function () {
                var self = this;
                return this.$q(function (resolve, reject) {
                    return self.MKioskService.getMyCharges(
                        { 
                            StartDate: self.periodStartDate.format('YYYY-MM-DD'), 
                            EndDate: self.periodEndDate.format('YYYY-MM-DD') 
                        }).then(function(data) {
                            
                            // for test red color
                            // data.Public.CostIncreaseVsCheapestOption = 30.5;                            
                            if (data.HomeChargersWithSyncError && data.HomeChargersWithSyncError.length > 0) {
                                self.homeChargersWithSyncError = data.HomeChargersWithSyncError;

                                // for test multi chargers
                                // self.homeChargersWithSyncError.push('Home - 60211-A1-2149-00514-C8');
                            }


                            var result = [
                                {
                                    key: 'HomeCharges',
                                    type: 'Home',
                                    data: data.Home
                                },
                                {
                                    key: 'PublicCharges',
                                    type: 'Public',
                                    data: data.Public
                                },
                                {
                                    key: 'OfficeCharges',
                                    type: 'Office',
                                    data: data.Office
                                }
                            ];              
                            for(var c of result) {
                                for(var d of c.data.ConsumptionPerPeriods) {
                                    // NF-1004 - CPE/05: special item for translation
                                    if (d.Period === 'HomeChargesNotYetReimbursed') {
                                        d.PeriodView = self.$message.get('NotYetReimbursed')
                                    } else {
                                        d.PeriodView =  moment(d.Period, 'YYYY-MM', 'en')
                                        .locale(moment.locale())
                                        .format('MMMM YYYY');
                                    }
                                }
                            }
                            resolve(result);
                        }, reject);
                })
                
            },
            selectPeriod: function ($event) {
                var self = this;
                this.$mdDialog.show({
                    controller: 'SelectPeriodCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'js/shared/select-period/select-period.view.html',
                    parent: angular.element(document.body),
                    targetEvent: $event,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        titleKey: 'PeriodForStatistics',
                        startDate: this.periodStartDate.toDate(),
                        endDate: this.periodEndDate.toDate()
                    }
                }).then(function (answer) {
                    self.periodStartDate = moment(answer.startDate);
                    self.periodEndDate = moment(answer.endDate);

                    self.savePeriod();
                    self.doRefresh();
                });
            },
            savePeriod: function () {

                sessionStorage.setItem('mycharges-period', 
                    JSON.stringify({ 
                        start: this.periodStartDate.format('YYYY-MM-DD'),
                        end: this.periodEndDate.format('YYYY-MM-DD') 
                    }));
            },
            restorePeriod: function () {
                var saved = sessionStorage.getItem('mycharges-period');
                if (saved) {

                    try {
                        var savedJson = JSON.parse(saved);
                        var start = moment(savedJson.start, 'YYYY-MM-DD');
                        var end = moment(savedJson.end, 'YYYY-MM-DD');
    
                        if (start.isValid() && end.isValid()) {
                            this.periodStartDate = start;
                            this.periodEndDate = end;
                        } else {
                            // for something happend, we need to clean bad data
                            sessionStorage.removeItem('mycharges-period');
                        }                    
                    } catch(e) {
                        console.error(e);                        
                        sessionStorage.removeItem('mycharges-period');
                    }
                    
                }
            },
            doRefresh : function (item) {
                var self = this;
                this.loadData().then(angular.bind(this, function (chargeData) {
                    self.myChargesData = chargeData;
                }), this.$message.error).finally(() => {
                     self.$scope.$broadcast('scroll.refreshComplete');
                });
            },
            onSeeAll: function (item) {
                //internal.homecharges-all-periods
                //internal.publiccharges-all-periods
                //internal.officecharges-all-periods
                this.$state.go(`internal.${item.type}charges-all-periods`.toLowerCase());
            },
            onChargePeriodClick: function (item) {
                this.$state.go(`internal.mycharges-consumption-details`, 
                    { period: item.period.Period, type: item.section.type, pre: this.$state.current.name });
            }
        };
        MyChargesCtrl.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'localStorageService', '$mdDialog', '$ionicScrollDelegate', '$timeout', 'MKioskService', '$message', '$q'];
        return MyChargesCtrl;
    }());
    angular.module('internal.mycharges').controller('MyChargesCtrl', MyChargesCtrl)
})();


